
import layout from '../../styles/_layout.module.scss'
import s from './profile.module.scss'
import { Nav } from '../Nav/Nav'
import { ArrowBackIcon } from '../../icons/arrowback-icon'
import { CustomButtom } from '../common/CustomButton/CustomButton'
import { ShareIcon } from '../../icons/share-icon'
import { ThreeDotsIcon } from '../../icons/threedots-icon'
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { IReward, MeSlice, getMe } from '../../store/slice/meSlice';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { UserIcon } from '../../icons/user-icon';
import { PhotoIcon } from '../../icons/photo-icon';
import { setPhoto } from '../../store/slice/setUserPhotoSlice';
import { InfoIcon } from '../../icons/info-icon';
import { EditIcon } from '../../icons/edit-icon';
import { KubokIcon } from '../../icons/kubok-icon';
import { Overlay } from '../common/Overlay/Overlay';
import { CalendarIcon } from '../../icons/calendar-icon';
import { MarkerIcon } from '../../icons/marker-icon';
import { MnInput } from '../common/MnInput/MnInput';
import { DatePicker, Dropdown, MenuProps, Select, Spin } from 'antd';
import mnInput from '../common/MnInput/mn-input.module.scss'
import { updateUser } from '../../store/slice/userUpdateSlice';
import { useFormik } from 'formik';
import { ProfileEditInfo } from './ProfileEditInfo';
import { getCountries } from '../../store/slice/getCountriesSlice';
import { AwardItem } from '../Award/AwardItem';
import { ChangePassword } from './ChangePassword';
import { customRoute } from '../../utilities';
import { Scripts } from '../common/Scripts/Scripts';
import { Subscription } from './Subscription';
import { AddProfile } from './AddProfile';
import { AddAward } from '../Award/AddAward';
import { StaticSlice, setProfileEdit, setSubUser, setSupport } from '../../store/slice/staticSlice';
import { backUser } from '../../store/slice/tokenSlice';
import { GetSports, ISport, getSports } from '../../store/slice/getSportsSlice';
import { GetUserRewards, getUserRewards } from '../../store/slice/getUserRewardsSlice';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import { Share } from '../common/Share/Share'

const genderList = ["Муж", "Жен"]

interface ISportsFilter { id: number, title: string, qty: number }

export const Profile = () => {
    const { success, data, loading } = useAppSelector(MeSlice)
    const dispatch = useAppDispatch()
    const router = useNavigate();
    const inputFile = useRef() as MutableRefObject<HTMLInputElement>
    const [progress, setProgress] = useState(0)
    const [infoStatus, setInfoStatus] = useState(false)
    // const [editStatus, setEditStatus] = useState(false)
    const [shareStatus, setShareStatus] = useState(false)
    const [subsStatus, setSubsStatus] = useState(false)
    const [addStatus, setAddStatus] = useState(false)
    const [profileStatus, setProfileStatus] = useState(false)
    const [changePasswordStatus, setChangePasswordStatus] = useState(false)
    const [subsTitle, setSubsTitle] = useState('Управлять подпиской')
    const [profileTitle, setProfileTitle] = useState('Добавить профиль')
    const { profileEdit, isSubUser } = useAppSelector(StaticSlice)
    const { success: sSuccess, data: sData } = useAppSelector(GetSports)
    const [sportsFilter, setSportsFilter] = useState<ISportsFilter[]>([] as ISportsFilter[])
    const { success: rSuccess, loading: rLoading, data: rewards } = useAppSelector(GetUserRewards)



    const setEditStatus = (status: boolean, subuser: boolean = false) => {
        dispatch(setSubUser(subuser))
        dispatch(setProfileEdit(status))
    }

    const clickHandler = (e: any) => {
        e.preventDefault()
        const files = Array.prototype.slice.call(inputFile.current.files);
        const formData = new FormData();
        formData.append('file', files[0]);
        const token = localStorage.getItem('access');
        dispatch(setPhoto({
            token: token,
            data: formData
        })).then((resp: any) => {
            if (!resp.error) {
                dispatch(getMe({ token: localStorage.getItem("access") }))
            }
        })
    }

    useEffect(() => {
        if (sSuccess) {
            sData.map((sport: ISport) => {
                setSportsFilter(curSPortsList => [...curSPortsList, { id: sport.id, title: sport.title, qty: 0 }])
            })
        }
    }, [sSuccess])

    useEffect(() => {
        if (sSuccess && success) {
            // Функция для создания объекта для array3
            const createArray3Object = (event: ISport) => {
                const eventID = event.id;
                const matchingSports = rewards.filter(sport => sport?.sport?.id === eventID);
                return {
                    id: event.id,
                    title: event.title,
                    qty: matchingSports.length
                };
            };

            // Создаем array3
            const newArray3 = sData.map(event => createArray3Object(event));
            setSportsFilter(newArray3);
        }
    }, [sSuccess, rSuccess, sData, rewards])

    useEffect(() => {
        dispatch(getMe({ token: localStorage.getItem("access") })).then((resp: any) => {
            if (resp.error) {
                customRoute('/auth')
            }
        })
        dispatch(getSports({}))
        dispatch(getCountries({}))

        return () => {
            setSportsFilter([] as ISportsFilter[])
        }
    }, [])

    useEffect(() => {
        if (!loading && success) {
            dispatch(getUserRewards({
                id: data.id
            }))
        }
    }, [success, data, loading])

    useEffect(() => {
        let _progress = 0
        if (!!data?.profile?.first_name) {
            _progress += 10
        }
        if (!!data?.profile?.last_name) {
            _progress += 10
        }
        if (!!data?.profile?.middle_name) {
            _progress += 10
        }
        if (!!data?.profile?.gender) {
            _progress += 10
        }
        if (!!data?.profile?.birth_date) {
            _progress += 10
        }
        if (!!data?.profile?.country) {
            _progress += 10
        }
        if (!!data?.profile?.city) {
            _progress += 10
        }
        if (!!data?.profile?.bio) {
            _progress += 10
        }
        if (rewards?.length > 0) {
            _progress += 20
        }
        setProgress(_progress)
    }, [data])


    const items: MenuProps['items'] = [
        {
            label: <span className={layout.menuItem} onClick={() => { setSubsStatus(true) }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="16" height="16" rx="8" fill="white" />
                    <g clipPath="url(#clip0_1235_14052)">
                        <path d="M6.16661 3.66699L4.66661 7.20699C4.64586 7.25749 4.63784 7.31231 4.64324 7.36664C4.64864 7.42097 4.6673 7.47314 4.69758 7.51856C4.72787 7.56399 4.76885 7.60128 4.81692 7.62716C4.86499 7.65304 4.91868 7.66672 4.97327 7.66699H6.83327L5.49994 12.3337L11.2266 6.90699C11.2742 6.86116 11.3071 6.80222 11.3211 6.73766C11.3351 6.6731 11.3296 6.60584 11.3053 6.54441C11.281 6.48297 11.239 6.43014 11.1847 6.39262C11.1303 6.3551 11.066 6.33458 10.9999 6.33366H8.49994L9.83327 3.66699H6.16661Z" fill="white" stroke="#DDBE90" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1235_14052">
                            <rect width="9.33333" height="9.33333" fill="white" transform="translate(3.33325 3.3335)" />
                        </clipPath>
                    </defs>
                </svg>
                <span>Подписка / Смена плана</span></span>,
            key: '0',
            disabled: true
        },
        // {
        //     type: 'divider',
        // },
        {
            label: <span className={layout.menuItem} onClick={() => { setProfileStatus(true) }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00008 2.6665C6.94525 2.6665 5.9141 2.9793 5.03704 3.56533C4.15998 4.15137 3.47639 4.98432 3.07273 5.95886C2.66906 6.9334 2.56344 8.00575 2.76923 9.04032C2.97502 10.0749 3.48297 11.0252 4.22885 11.7711C4.97473 12.5169 5.92504 13.0249 6.9596 13.2307C7.99417 13.4365 9.06652 13.3309 10.0411 12.9272C11.0156 12.5235 11.8486 11.8399 12.4346 10.9629C13.0206 10.0858 13.3334 9.05467 13.3334 7.99984C13.3319 6.58581 12.7695 5.23012 11.7697 4.23025C10.7698 3.23038 9.41411 2.668 8.00008 2.6665ZM5.23496 11.5639C5.53174 11.0998 5.9406 10.7178 6.42384 10.4532C6.90708 10.1886 7.44915 10.0499 8.00008 10.0499C8.55102 10.0499 9.09309 10.1886 9.57633 10.4532C10.0596 10.7178 10.4684 11.0998 10.7652 11.5639C9.97461 12.1788 9.00163 12.5126 8.00008 12.5126C6.99853 12.5126 6.02555 12.1788 5.23496 11.5639ZM6.35906 7.58958C6.35906 7.26501 6.4553 6.94774 6.63562 6.67787C6.81594 6.40801 7.07223 6.19767 7.37209 6.07347C7.67195 5.94926 8.0019 5.91677 8.32023 5.98009C8.63856 6.0434 8.93096 6.1997 9.16046 6.4292C9.38996 6.6587 9.54626 6.9511 9.60958 7.26943C9.6729 7.58776 9.6404 7.91771 9.51619 8.21757C9.39199 8.51743 9.18165 8.77372 8.91179 8.95404C8.64192 9.13436 8.32465 9.2306 8.00008 9.2306C7.56486 9.2306 7.14745 9.05771 6.8397 8.74996C6.53195 8.44221 6.35906 8.02481 6.35906 7.58958ZM11.3724 10.9952C10.9148 10.3322 10.2715 9.81923 9.52316 9.52086C9.92512 9.20427 10.2184 8.77029 10.3623 8.27927C10.5062 7.78825 10.4935 7.2646 10.3259 6.78114C10.1584 6.29768 9.84438 5.87844 9.42754 5.58173C9.01069 5.28501 8.51175 5.12557 8.00008 5.12557C7.48842 5.12557 6.98947 5.28501 6.57263 5.58173C6.15578 5.87844 5.84176 6.29768 5.67423 6.78114C5.5067 7.2646 5.49399 7.78825 5.63786 8.27927C5.78174 8.77029 6.07505 9.20427 6.47701 9.52086C5.72871 9.81923 5.08533 10.3322 4.62778 10.9952C4.04961 10.345 3.67171 9.5416 3.53959 8.68163C3.40748 7.82166 3.52677 6.94183 3.88312 6.14809C4.23946 5.35435 4.81766 4.68054 5.54809 4.2078C6.27851 3.73507 7.13002 3.48355 8.00008 3.48355C8.87014 3.48355 9.72165 3.73507 10.4521 4.2078C11.1825 4.68054 11.7607 5.35435 12.117 6.14809C12.4734 6.94183 12.5927 7.82166 12.4606 8.68163C12.3285 9.5416 11.9506 10.345 11.3724 10.9952Z" fill="white" />
                </svg>

                <span>Добавить профиль +</span></span>,
            key: '1',
            disabled: data.is_subuser
        },
        {
            label: <span className={layout.menuItem} onClick={() => {
                dispatch(backUser(
                    { token: localStorage.getItem('access') }
                )).then((resp: any) => {
                    if (!resp.error) {
                        dispatch(getMe({ token: localStorage.getItem('access') }))
                    }
                })
            }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00008 2.6665C6.94525 2.6665 5.9141 2.9793 5.03704 3.56533C4.15998 4.15137 3.47639 4.98432 3.07273 5.95886C2.66906 6.9334 2.56344 8.00575 2.76923 9.04032C2.97502 10.0749 3.48297 11.0252 4.22885 11.7711C4.97473 12.5169 5.92504 13.0249 6.9596 13.2307C7.99417 13.4365 9.06652 13.3309 10.0411 12.9272C11.0156 12.5235 11.8486 11.8399 12.4346 10.9629C13.0206 10.0858 13.3334 9.05467 13.3334 7.99984C13.3319 6.58581 12.7695 5.23012 11.7697 4.23025C10.7698 3.23038 9.41411 2.668 8.00008 2.6665ZM5.23496 11.5639C5.53174 11.0998 5.9406 10.7178 6.42384 10.4532C6.90708 10.1886 7.44915 10.0499 8.00008 10.0499C8.55102 10.0499 9.09309 10.1886 9.57633 10.4532C10.0596 10.7178 10.4684 11.0998 10.7652 11.5639C9.97461 12.1788 9.00163 12.5126 8.00008 12.5126C6.99853 12.5126 6.02555 12.1788 5.23496 11.5639ZM6.35906 7.58958C6.35906 7.26501 6.4553 6.94774 6.63562 6.67787C6.81594 6.40801 7.07223 6.19767 7.37209 6.07347C7.67195 5.94926 8.0019 5.91677 8.32023 5.98009C8.63856 6.0434 8.93096 6.1997 9.16046 6.4292C9.38996 6.6587 9.54626 6.9511 9.60958 7.26943C9.6729 7.58776 9.6404 7.91771 9.51619 8.21757C9.39199 8.51743 9.18165 8.77372 8.91179 8.95404C8.64192 9.13436 8.32465 9.2306 8.00008 9.2306C7.56486 9.2306 7.14745 9.05771 6.8397 8.74996C6.53195 8.44221 6.35906 8.02481 6.35906 7.58958ZM11.3724 10.9952C10.9148 10.3322 10.2715 9.81923 9.52316 9.52086C9.92512 9.20427 10.2184 8.77029 10.3623 8.27927C10.5062 7.78825 10.4935 7.2646 10.3259 6.78114C10.1584 6.29768 9.84438 5.87844 9.42754 5.58173C9.01069 5.28501 8.51175 5.12557 8.00008 5.12557C7.48842 5.12557 6.98947 5.28501 6.57263 5.58173C6.15578 5.87844 5.84176 6.29768 5.67423 6.78114C5.5067 7.2646 5.49399 7.78825 5.63786 8.27927C5.78174 8.77029 6.07505 9.20427 6.47701 9.52086C5.72871 9.81923 5.08533 10.3322 4.62778 10.9952C4.04961 10.345 3.67171 9.5416 3.53959 8.68163C3.40748 7.82166 3.52677 6.94183 3.88312 6.14809C4.23946 5.35435 4.81766 4.68054 5.54809 4.2078C6.27851 3.73507 7.13002 3.48355 8.00008 3.48355C8.87014 3.48355 9.72165 3.73507 10.4521 4.2078C11.1825 4.68054 11.7607 5.35435 12.117 6.14809C12.4734 6.94183 12.5927 7.82166 12.4606 8.68163C12.3285 9.5416 11.9506 10.345 11.3724 10.9952Z" fill="white" />
                </svg>

                <span>Вернуться в основной профиль</span></span>,
            key: '1',
            disabled: !data.is_subuser
        },
        {
            type: 'divider',
        },
        {
            label: <span className={layout.menuItem} onClick={() => setEditStatus(true)}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.66675 12.4764H13.3334V13.2383H2.66675V12.4764ZM11.581 6.00016C11.8858 5.6954 11.8858 5.23826 11.581 4.9335L10.2096 3.56207C9.90484 3.25731 9.4477 3.25731 9.14294 3.56207L3.42865 9.27635V11.7144H5.86675L11.581 6.00016ZM9.67627 4.0954L11.0477 5.46683L9.90484 6.60969L8.53341 5.23826L9.67627 4.0954ZM4.19056 10.9525V9.58112L8.00008 5.77159L9.37151 7.14302L5.56199 10.9525H4.19056Z" fill="white" />
                </svg>

                <span>Редактировать профиль</span></span>,
            key: '2',
        },
        {
            type: 'divider',
        },
        {
            label: <span className={layout.menuItem} onClick={() => { setChangePasswordStatus(true) }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.9523 6.22206H11.9682C12.1029 6.22206 12.2321 6.27557 12.3273 6.37083C12.4226 6.46609 12.4761 6.59528 12.4761 6.73V12.8252C12.4761 12.9599 12.4226 13.0891 12.3273 13.1844C12.2321 13.2797 12.1029 13.3332 11.9682 13.3332H3.84119C3.70648 13.3332 3.57728 13.2797 3.48202 13.1844C3.38677 13.0891 3.33325 12.9599 3.33325 12.8252V6.73C3.33325 6.59528 3.38677 6.46609 3.48202 6.37083C3.57728 6.27557 3.70648 6.22206 3.84119 6.22206H4.85706V5.71412C4.85706 4.90584 5.17815 4.13067 5.74969 3.55913C6.32123 2.98759 7.0964 2.6665 7.90468 2.6665C8.71296 2.6665 9.48813 2.98759 10.0597 3.55913C10.6312 4.13067 10.9523 4.90584 10.9523 5.71412V6.22206ZM4.34913 7.23793V12.3173H11.4602V7.23793H4.34913ZM7.39674 9.26968H8.41262V10.2856H7.39674V9.26968ZM5.365 9.26968H6.38087V10.2856H5.365V9.26968ZM9.42849 9.26968H10.4444V10.2856H9.42849V9.26968ZM9.93643 6.22206V5.71412C9.93643 5.17527 9.72237 4.65849 9.34134 4.27746C8.96032 3.89644 8.44353 3.68238 7.90468 3.68238C7.36583 3.68238 6.84905 3.89644 6.46802 4.27746C6.08699 4.65849 5.87293 5.17527 5.87293 5.71412V6.22206H9.93643Z" fill="white" />
                </svg>

                <span>Изменить пароль</span></span>,
            key: '3',
        },
        {
            type: 'divider',
        },
        {
            label: <span className={layout.menuItem} onClick={() => { dispatch(setSupport(true)) }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.99992 3.3335C5.42672 3.3335 3.33325 5.42696 3.33325 8.00016V9.93356C3.33325 10.4114 3.75185 10.8002 4.26659 10.8002H4.73325C4.85702 10.8002 4.97572 10.751 5.06324 10.6635C5.15075 10.576 5.19992 10.4573 5.19992 10.3335V7.93343C5.19992 7.80966 5.15075 7.69096 5.06324 7.60345C4.97572 7.51593 4.85702 7.46676 4.73325 7.46676H4.30952C4.56899 5.66076 6.12299 4.26683 7.99992 4.26683C9.87685 4.26683 11.4309 5.66076 11.6903 7.46676H11.2666C11.1428 7.46676 11.0241 7.51593 10.9366 7.60345C10.8491 7.69096 10.7999 7.80966 10.7999 7.93343V10.8002C10.7999 11.3149 10.3813 11.7335 9.86659 11.7335H8.93325V11.2668H7.06659V12.6668H9.86659C10.8961 12.6668 11.7333 11.8296 11.7333 10.8002C12.248 10.8002 12.6666 10.4114 12.6666 9.93356V8.00016C12.6666 5.42696 10.5731 3.3335 7.99992 3.3335Z" fill="white" />
                </svg>

                <span>Связаться с поддержкой</span></span>,
            key: '4',
        },
        {
            type: 'divider',
        },
        {
            label: <Link to="https://help.моинаграды.рф/privacy" target='_blank' className={layout.menuItem} onClick={() => { }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M4.41572 3.08222C4.6819 2.81604 5.04292 2.6665 5.41935 2.6665H9.54942C9.68907 2.66652 9.82682 2.69893 9.95184 2.76117C10.0769 2.82341 10.1857 2.91379 10.2699 3.02521L11.8173 5.07321C11.936 5.23012 12 5.42108 12 5.61773V11.3117C12 11.6881 11.8505 12.0491 11.5843 12.3153C11.3181 12.5815 10.9571 12.731 10.5806 12.731H5.41935C5.04292 12.731 4.6819 12.5815 4.41572 12.3153C4.14954 12.0491 4 11.6881 4 11.3117V4.08586C4 3.70942 4.14954 3.3484 4.41572 3.08222ZM5.41935 3.4407C5.06323 3.4407 4.77419 3.72973 4.77419 4.08586V11.3117C4.77419 11.6678 5.06323 11.9568 5.41935 11.9568H10.5806C10.9368 11.9568 11.2258 11.6678 11.2258 11.3117V6.09721H9.54839C9.33471 6.09721 9.16129 5.92379 9.16129 5.71012V3.4407H5.41935ZM9.82211 7.94117C9.8947 8.01377 9.93548 8.11223 9.93548 8.21489C9.93548 8.31755 9.8947 8.41601 9.82211 8.48861C9.74951 8.5612 9.65105 8.60199 9.54839 8.60199H6.45161C6.34895 8.60199 6.25049 8.5612 6.17789 8.48861C6.1053 8.41601 6.06452 8.31755 6.06452 8.21489C6.06452 8.11223 6.1053 8.01377 6.17789 7.94117C6.25049 7.86858 6.34895 7.82779 6.45161 7.82779H9.54839C9.65105 7.82779 9.74951 7.86858 9.82211 7.94117ZM9.82211 10.0057C9.8947 10.0783 9.93548 10.1767 9.93548 10.2794C9.93548 10.3821 9.8947 10.4805 9.82211 10.5531C9.74951 10.6257 9.65105 10.6665 9.54839 10.6665H6.45161C6.34895 10.6665 6.25049 10.6257 6.17789 10.5531C6.1053 10.4805 6.06452 10.3821 6.06452 10.2794C6.06452 10.1767 6.1053 10.0783 6.17789 10.0057C6.25049 9.93309 6.34895 9.89231 6.45161 9.89231H9.54839C9.65105 9.89231 9.74951 9.93309 9.82211 10.0057Z" fill="white" />
                </svg>

                <span>Условия пользования</span></Link>,
            key: '5',
        },
        {
            type: 'divider',
        },
        {
            label: <span className={layout.menuItem} onClick={() => {
                localStorage.removeItem('access')
                localStorage.removeItem('refresh')
                customRoute('/auth')
            }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.88889 13C5.64445 13 5.43511 12.8911 5.26089 12.6733C5.08667 12.4556 4.9997 12.1941 5 11.8889V4.11111C5 3.80555 5.08711 3.54389 5.26133 3.32611C5.43556 3.10833 5.64474 2.99963 5.88889 3H9V4.11111H5.88889V11.8889H9V13H5.88889ZM10.7778 10.7778L10.1667 9.97222L11.3 8.55555H7.66667V7.44444H11.3L10.1667 6.02778L10.7778 5.22222L13 8L10.7778 10.7778Z" fill="white" />
                </svg>
                <span>Выйти</span></span>,
            key: '6',
        },
    ];

    const breakString = (str: string) => {
        const words = str.split(' ');
        const firstWord = words[0];
        const restOfWords = words.slice(1).join(' ');

        if (restOfWords.length === 0) {
            return (<div>{firstWord}</div>)
        }
        return (<><div className={s.statFirstLine}>{firstWord}</div><div className={s.statSecondLine}>{restOfWords}</div></>)
    }


    const ProfileUserInfo = () => {
        return (<>
            <div className={s.profileUserInfo}>
                <div className={s.profileUserInfoItem}>
                    <div className={s.profileUserInfoIcon}>
                        <CalendarIcon />
                    </div>
                    <div className={s.profileUserInfoData}>
                        <div className={s.profileUserInfoDataTitle}>
                            Дата рождения:
                        </div>
                        <div className={s.profileUserInfoDataText}>
                            {data?.profile?.birth_date}
                        </div>
                    </div>
                </div>
                <div className={s.profileUserInfoItem}>
                    <div className={s.profileUserInfoIcon}>
                        <MarkerIcon />
                    </div>
                    <div className={s.profileUserInfoData}>
                        <div className={s.profileUserInfoDataTitle}>
                            Место проживания
                        </div>
                        <div className={s.profileUserInfoDataText}>
                            {data?.profile?.country?.name}, {data?.profile?.city?.name}
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }



    return (<>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Профиль | Мои награды</title>
            <meta name="description" content="Ваши награды и результаты соревнований"
            />
        </Helmet>
        <div className={layout.container}>
            <div className={layout.content}>
                <div className={s.profileHeader}>
                    <div className={layout.round} onClick={() => { customRoute('/awards') }}>
                        <ArrowBackIcon />
                    </div>
                    <div className={layout.pageName}>Профиль</div>
                    <div className={layout.headerButtons}>
                        <button className={s.shareButton} onClick={() => { setShareStatus(true) }}><ShareIcon /></button>
                        <Dropdown overlayClassName={'profileDropDown'} menu={{ items }} trigger={['click']}>
                            <div className={layout.round} onClick={(e) => e.preventDefault()}>
                                <ThreeDotsIcon />
                            </div>
                        </Dropdown>

                    </div>
                </div>
                <div className={s.userNameBlock}>
                    <div className={s.userAvatar}>
                        {!data?.profile?.image && <>
                            <div className={s.avatar} onClick={() => {
                                inputFile.current.click()
                            }}>
                                <UserIcon size={16} />
                            </div>
                            <input onChange={e => { clickHandler(e) }} type='file' id='file' ref={inputFile} style={{ display: 'none' }} />
                            <div className={s.addPhotoButton} onClick={() => {
                                inputFile.current.click()
                            }}><PhotoIcon size={10} fill="#E9E9E9" /></div></>}
                        {data?.profile?.image &&
                            <div className={s.avatar}>
                                <img width={64} height={64} alt="" src={data.profile.image} className={s.avatarImage} />
                            </div>}
                    </div>
                    <div className={s.userName}>
                        {/* {data?.profile?.first_name && data?.profile?.first_name} {data?.profile?.last_name && data?.profile?.last_name} */}
                        {data?.profile?.full_name}
                    </div>
                    <div className={s.info} onClick={() => { setInfoStatus(true) }}>
                        <InfoIcon />
                    </div>
                </div>
                <div className={s.userProgressBlock}>
                    <div className={s.userProgressBlockInfo}>
                        <div className={s.userProgressBlockInfoText}>
                            <div className={s.userProgressBlockInfoTextTitle}>
                                Прогресс профиля
                            </div>
                            <div className={s.userProgressBlockInfoTextContent}>
                                Добавьте больше информации о себе и продлите бесплатную подписку🥳
                            </div>
                        </div>
                        <div className={s.userProgressBlockInfoEdit}>
                            <span onClick={() => setEditStatus(true)}><EditIcon /></span>
                        </div>
                    </div>
                    <div className={s.userProgressBlockBar}>
                        <div className={s.userProgressBlockBarPercent}
                            style={{ width: `${progress}%` }}
                        >
                        </div>
                    </div>
                </div>
                {!!data?.profile?.bio && <div className={s.userAboutBlock}>
                    <div className={s.userAboutBlockTitle}>
                        Обо мне:
                    </div>
                    <div className={s.userAboutBlockContent}>
                        {data?.profile?.bio}
                    </div>
                </div>}
                <div className={s.userStatisticsBlock}>
                    <div className={s.userStatisticsBlockTitle}>
                        Статистика
                    </div>
                    <div className={s.userStatisticsBlockBlocks}>
                        <div className={s.userStatisticsBlockTotal}>
                            <div className={s.userStatisticsBlockTotalTitle}>
                                Всего наград
                            </div>
                            <div className={s.userStatisticsBlockTotalValue}>
                                {rewards?.length}
                            </div>
                            <div className={s.userStatisticsBlockTotalRound}>
                                <KubokIcon />
                            </div>
                        </div>
                        {success && rewards?.filter(reward => reward.category === "non_sport").length > 0 &&
                            <div className={s.userStatisticsBlockItem}>
                                <div className={s.userStatisticsBlockItemTitle}>
                                    Неспортивные награды
                                </div>
                                <div className={s.userStatisticsBlockItemValue}>
                                    {rewards.filter(reward => reward.category === "non_sport").length}
                                </div>
                                <div className={s.userStatisticsBlockItemRound}>
                                </div>
                            </div>
                        }
                        {sportsFilter.filter(sport => sport.qty > 0).map((st: ISportsFilter, i: number) => {
                            return (<div key={i} className={s.userStatisticsBlockItem}>
                                <div className={s.userStatisticsBlockItemTitle}>
                                    {breakString(st.title)}
                                </div>
                                <div className={s.userStatisticsBlockItemValue}>
                                    {st.qty}
                                </div>
                                <div className={s.userStatisticsBlockItemRound}>
                                </div>
                            </div>)
                        })
                        }
                        {/* <div className={s.userStatisticsBlockItem}>
                            <div className={s.userStatisticsBlockItemTitle}>
                                Бухое ползание
                            </div>
                            <div className={s.userStatisticsBlockItemValue}>
                                120
                            </div>
                            <div className={s.userStatisticsBlockItemRound}>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className={s.userRewardsBlock}>
                    <div className={s.userRewardsBlockTitle}>
                        Награды
                        <span style={{ cursor: 'pointer', width: 32, height: 32 }}
                            onClick={() => { setAddStatus(true) }}
                            className={layout.addAwardProfileButton}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="32" height="32" rx="16" fill="#DDBE90" />
                                <path d="M21.0001 16.8317H16.8334V20.9984C16.8334 21.2194 16.7456 21.4313 16.5893 21.5876C16.4331 21.7439 16.2211 21.8317 16.0001 21.8317C15.7791 21.8317 15.5671 21.7439 15.4108 21.5876C15.2545 21.4313 15.1667 21.2194 15.1667 20.9984V16.8317H11.0001C10.7791 16.8317 10.5671 16.7439 10.4108 16.5876C10.2545 16.4313 10.1667 16.2194 10.1667 15.9984C10.1667 15.7774 10.2545 15.5654 10.4108 15.4091C10.5671 15.2528 10.7791 15.165 11.0001 15.165H15.1667V10.9984C15.1667 10.7774 15.2545 10.5654 15.4108 10.4091C15.5671 10.2528 15.7791 10.165 16.0001 10.165C16.2211 10.165 16.4331 10.2528 16.5893 10.4091C16.7456 10.5654 16.8334 10.7774 16.8334 10.9984V15.165H21.0001C21.2211 15.165 21.4331 15.2528 21.5893 15.4091C21.7456 15.5654 21.8334 15.7774 21.8334 15.9984C21.8334 16.2194 21.7456 16.4313 21.5893 16.5876C21.4331 16.7439 21.2211 16.8317 21.0001 16.8317Z" fill="white" />
                            </svg>

                        </span>
                    </div>
                    <Spin spinning={loading}>
                        <div className={layout.awardList}>
                            {rewards?.map((reward: IReward, index: number) => {

                                return (<>
                                    <AwardItem award={reward} key={index} />
                                </>)
                            })}
                        </div>
                    </Spin>
                </div>
                <div className={s.userAlbumsBlock}>

                </div>
            </div>

            <div className={layout.footer}>
                <Nav active='profile' />
            </div>
        </div>
        <Scripts />
        {infoStatus && <Overlay
            title={data?.profile?.full_name}
            status={infoStatus}
            setStatus={setInfoStatus}>
            <ProfileUserInfo />
        </Overlay>}
        {profileEdit && <Overlay
            title='Изменить профиль'
            status={profileEdit}
            setStatus={setEditStatus}>
            <ProfileEditInfo subuser={isSubUser} setStatus={setEditStatus} />
        </Overlay>}
        {changePasswordStatus && <Overlay
            title='Изменить пароль'
            status={changePasswordStatus}
            setStatus={setChangePasswordStatus}>
            <ChangePassword />
        </Overlay>}
        {subsStatus && <Overlay
            title={subsTitle}
            status={subsStatus}
            setStatus={setSubsStatus}>
            <Subscription handleTitle={setSubsTitle} setStatus={setSubsStatus} />
        </Overlay>}
        {profileStatus && <Overlay
            title={profileTitle}
            status={profileStatus}
            setStatus={setProfileStatus}>
            <AddProfile setRewardStatus={setAddStatus} handleTitle={setProfileTitle} setStatus={setProfileStatus} />
        </Overlay>}
        {addStatus && <Overlay
            title={'Добавление награды'}
            status={addStatus}
            setStatus={setAddStatus}>
            <AddAward />
        </Overlay>}
        {shareStatus && <Overlay
            title={'Поделиться профилем'}
            status={shareStatus}
            setStatus={setShareStatus}>
            <Share link={window.location.protocol + '//' + window.location.host + '/user/' + data.id} />
        </Overlay>
        }
    </>
    )
}